var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGooglePlayWithBorder = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 42,
    viewBox: "0 0 40 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1672 9.1125L23.579 3.17312C21.3699 1.93398 18.6301 1.93398 16.421 3.17313L5.8328 9.1125C3.67676 10.3219 2.35294 12.5291 2.35294 14.9144L2.35294 27.0856C2.35294 29.4709 3.67676 31.6781 5.8328 32.8875L16.421 38.8269C18.6301 40.066 21.3699 40.066 23.579 38.8269L34.1672 32.8875C36.3232 31.6781 37.6471 29.4709 37.6471 27.0856V14.9144C37.6471 12.5291 36.3232 10.3219 34.1672 9.1125ZM24.772 1.23915C21.8265 -0.41305 18.1734 -0.413049 15.228 1.23915L4.63981 7.17852C1.76509 8.79107 0 11.734 0 14.9144L0 27.0856C0 30.266 1.76509 33.2089 4.63981 34.8215L15.228 40.7608C18.1734 42.413 21.8265 42.413 24.772 40.7608L35.3602 34.8215C38.2349 33.2089 40 30.266 40 27.0856V14.9144C40 11.734 38.2349 8.79107 35.3602 7.17852L24.772 1.23915Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1356 20.1839L24.8822 17.372L13.6344 11.0291C13.6344 11.0291 13.1113 10.9637 12.9805 11.0291C13.1766 11.2252 22.1356 20.1839 22.1356 20.1839Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9961 30.9712C13.1269 31.0366 13.65 30.9712 13.65 30.9712L24.8978 24.6282L22.1513 21.8164C22.1513 21.8164 13.1923 30.775 12.9961 30.9712Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0654 11.814C12.0654 11.814 12 12.0755 12 14.1681C12 16.2606 12 21.0342 12 21.0342C12 21.0342 12 25.8077 12 27.9003C12 29.9928 12.0654 30.2543 12.0654 30.2543L21.2859 21.0342L12.0654 11.814Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0948 21.0339C30.0948 20.4454 29.4592 20.053 29.4592 20.053L25.9933 18.0259L22.9512 21.0339C22.9512 21.0339 22.9531 21.0339 22.9558 21.0339L25.9979 24.0419L29.4638 22.0148C29.4638 22.0148 30.0994 21.6224 30.0994 21.0339C30.0981 21.0339 30.0961 21.0339 30.0948 21.0339Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGooglePlayWithBorder);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/google-play-with-border.82b838fa639aded776f6e88bb8bb9503.svg";